<template>
  <v-skeleton-loader class="mx-auto" :loading="loading" type="card">
    <v-card outlined>
      <v-card-title>CMS Summary</v-card-title>
      <v-simple-table height="290">
        <template v-slot:default>
          <thead>
            <tr>
              <th>Field Name</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody v-for="item in reportData" v-bind:key="item._id">
            <tr>
              <td>CMS Original Factor</td>
              <td>{{ item.CMS_ORIGINAL_FACTOR ? item.CMS_ORIGINAL_FACTOR : '-' }}</td>
            </tr>
            <tr>
              <td>Medicaid Eligible</td>
              <td>{{ item.MEDICAID_ELIGIBLE ? item.MEDICAID_ELIGIBLE : '-' }}</td>
            </tr>
            <tr>
              <td>CMS HCC's</td>
              <td>{{ item.CMS_HCCS ? item.CMS_HCCS : '-' }}</td>
            </tr>
            <tr>
              <td>CMS Risk</td>
              <td>{{ item.CMS_RISK ? item.CMS_RISK : '-' }}</td>
            </tr>
            <tr>
              <td>Total Member Months</td>
              <td>{{ item.CMS_TOTAL_MEMBER_MONTHS ? item.CMS_TOTAL_MEMBER_MONTHS : '-' }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CmsSummary',
  props: [
    'value',
    'patientID',
    'organizations',
    'insurance',
    'startDate',
    'endDate',
    'providers',
    'groups',
    'locations',
  ],
  data() {
    return {
      loading: false,
      dialog: false,
      reportData: [],
      fireReport: false,
    };
  },
  created() {
    this.getReport();
  },
  methods: {
    async getReport() {
      const { startDate } = this;
      const { patientID } = this;
      const { endDate } = this;
      const { insurance } = this;
      const organizations = this.organization;
      const { groups } = this;
      const provNums = this.providers;
      const locs = this.locations;

      let providers = [];
      let locations = [];

      if (provNums.length > 0) {
        provNums.forEach((prov) => {
          if (providers.indexOf(prov.Center_PCP_Number) === -1) {
            providers.push(prov.Center_PCP_Number);
          }
        });
      } else {
        providers = [];
      }

      if (locs.length > 0) {
        locs.forEach((loca) => {
          if (locations.indexOf(loca.Center_Location) === -1) {
            locations.push(loca.Center_Location);
          }
        });
      } else {
        locations = [];
      }

      // Check for pending request and if so cancel old one for new incoming
      this.cancelSearch();
      // Set the CancelToken
      this.cancelSource = axios.CancelToken.source();

      if (insurance.length !== 0) {
        this.loading = true;
        this.reportData = [];

        const response = axios
          .get(
            `api/ai/modal/cmssummary/orgs=${organizations}/groups=${groups}/providers=${providers}/locs=${locations}/${insurance}/${startDate}/${endDate}/${patientID}`,
            { cancelToken: this.cancelSource.token }
          )
          .then((response) => {
            this.reportData = response.data;
            this.cancelSource = null;
            this.loading = false;
          });
      }
    },
    formatWord(phrase) {
      return phrase
        .toLowerCase()
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },

  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    // Watch every dropdown and run report again on change
    async groups() {
      this.getReport();
    },
    async providers() {
      this.getReport();
    },
    async locations() {
      this.getReport();
    },
    async startDate() {
      this.getReport();
    },
    async endDate() {
      this.getReport();
    },
    async patientID() {
      this.getReport();
    },
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
